module.exports = __webpack_public_path__ + "static/media/belem-pa.975bc856.jpg";